export const homework = {
    "homework_bank_title": "Homework Bank",
    "homework_bank_create": "Create Homework Bank",
    "homework_bank_edit": "Edit Homework Bank",
    "homework_bank_delete": "Delete Homework Bank",
    "homework_bank_delete_confirm": "Are you sure you want to delete this homeworkBank bank?",
    "homework_bank_name": "Name",
    "homework_bank_description": "Description",
    "homework_bank_type": "Type",
    "homework_bank_type_public": "Public",
    "homework_bank_type_class": "Class",
    "homework_bank_type_teacher": "Teacher",
    "homework_bank_type_auth_public": "Auth Public",
    "homework_bank_subject": "Subject",
    "homework_bank_class": "Class",
    "homework_bank_create_by": "Created By",
    "homework_bank_created_at": "Created At",
    "homework_bank_updated_at": "Updated At",
    "homework_bank_actions": "Actions",
    "homework_bank_edit_btn": "Edit",
    "homework_bank_delete_btn": "Delete",
    "homework_bank_view_cards": "Card View",
    "homework_bank_view_list": "List View",
    "homework_bank_filter_type": "Filter by Type",
    "homework_bank_filter_subject": "Filter by Subject",
    "homework_bank_filter_class": "Filter by Class",
    "homework_bank_empty": "No homeworkBank bank data",
    "homework_bank_loading": "Loading...",
    "homework_bank_create_first": "Create First Homework Bank",
    "homework_bank_name_placeholder": "Please enter homeworkBank bank name",
    "homework_bank_description_placeholder": "Please enter homeworkBank bank description (optional)",
    "homework_bank_name_required": "Please enter homeworkBank assignments name",
    "homework_bank_name_max": "Homework bank name cannot exceed 100 characters",
    "homework_bank_description_max": "Homework bank description cannot exceed 500 characters",
    "homework_bank_type_required": "Please select homeworkBank bank type",
    "homework_bank_create_success": "Created successfully",
    "homework_bank_update_success": "Updated successfully",
    "homework_bank_delete_success": "Deleted successfully",
    "homework_bank_create_failed": "Failed to create",
    "homework_bank_update_failed": "Failed to update",
    "homework_bank_delete_failed": "Failed to delete",
    "homework_bank_all_types": "All Types",
    "homework_bank_all_subjects": "All Subjects",
    "homework_bank_all_classes": "All Classes",
    "homework_bank_tab_teacher": "My Assignments",
    "homework_bank_tab_public": "Public Assignments",
    "homework_bank_tab_auth": "My Academic Assignments",

    "homework_bank_tab_instruction": "Instructions",

    "homework_bank_instruction_public_title":"Public Assignments",
    "homework_bank_instruction_public_desc": "Maintained by academic teachers. Contains shared homework templates for all teachers to use.",

    "homework_bank_instruction_auth_title":"My Academic Assignments",
    "homework_bank_instruction_auth_desc": "Private repository visible only to you. You can authorize specific classes to access it; their teachers can then view and assign homework from this bank.",

    "homework_bank_instruction_teacher_title":  "My Assignments",
    "homework_bank_instruction_teacher_desc": "Your personal homework bank. Store your own question sets and use them directly in your assigned classes.",


    "homework_bank_search_placeholder": "Search homeworkBank Bank name or description",
    "homework_bank_cancel": "Cancel",
    "homework_bank_view_btn": "View",
    "homework_temp_title": "Homework Template Detail",
    "homework_temp_back": "Back to Homework Bank",
    "homework_temp_upload_file": "Upload File",
    "homework_temp_upload_question": "Upload Question File (Required)",
    "homework_temp_upload_answer": "Upload Answer File (Optional)",
    "homework_temp_create_question": "Create Question",
    "homework_temp_edit_mode": "Edit Mode",
    "homework_temp_view_mode": "View Mode",
    "homework_temp_save": "Save",
    "homework_temp_cancel": "Cancel",
    "homework_temp_delete": "Delete",
    "homework_temp_add_question": "Add Question",
    "homework_temp_add_paragraph": "Add Paragraph",
    "homework_temp_question_type": "Question Type",
    "homework_temp_question_type_select": "Single Choice",
    "homework_temp_question_type_mutil_select": "Multiple Choice",
    "homework_temp_question_type_true_false": "True/False",
    "homework_temp_question_type_empty": "Paragraph",
    "homework_temp_question_type_simple_text": "Short Answer",
    "homework_temp_question_type_fill_blank": "Fill in the Blank",
    "homework_temp_question_type_essay": "Essay",
    "homework_temp_question_type_drag_select": "Drag & Fill",
    "homework_temp_question_type_match_line": "Matching",
    "homework_temp_question_type_pointer_select": "Pointer Selection",
    "homework_temp_question_type_sort_order": "Sort Order",
    "homework_temp_fill_blank_stem": "Sub-question",
    "homework_temp_fill_blank_ref_answer": "Reference answer (optional)",
    "homework_temp_add_fill_blank": "Add blank",
    "homework_temp_match_pair_source": "Source (left)",
    "homework_temp_match_pair_target": "Target (right)",
    "homework_temp_add_match_pair": "Add pair",
    "homework_temp_set_correct_pairs": "Set correct pairs",
    "homework_temp_match_pair_hint": "Each correct pair scores (full score / number of correct pairs)",
    "homework_temp_pointer_text": "Source text",
    "homework_temp_pointer_positions": "Selectable positions",
    "homework_temp_pointer_edit_positions": "Edit selectable positions",
    "homework_temp_pointer_edit_answers": "Edit correct answers",
    "homework_temp_pointer_select_hint": "Click characters below; correct answers must be a subset of selectable positions",
    "homework_temp_pointer_teacher_hint": "Click a character to add a pointer; click the circle below to mark the correct answer (filled = selected)",
    "homework_temp_pointer_click_toggle_position": "Toggle selectable position (index {{index}})",
    "homework_temp_pointer_mark_correct": "Mark as correct answer",
    "homework_temp_pointer_positions_summary": "Selectable: [{{positions}}]; Correct: [{{answers}}]",
    "homework_temp_match_setup_title": "Options and correct pairs",
    "homework_temp_match_setup_desc": "Fill in all left (source) and right (target) option texts below, then drag or connect in the panel above.",
    "homework_temp_match_column_source": "Left (source)",
    "homework_temp_match_column_target": "Right (target)",
    "homework_temp_match_add_source": "Add left item",
    "homework_temp_match_add_target": "Add right item",
    "homework_temp_match_fill_options_first": "Enter at least one left and one right option first",
    "homework_temp_match_empty_slot": "(empty)",
    "homework_temp_match_line_connect_hint": "Matching: click a left item, then a right item to connect. Click the same pair again to remove. Many-to-many supported.",
    "homework_temp_match_drag_connect_hint": "Drag & match: drag from left to right. One left item can connect to multiple right items.",
    "homework_temp_match_many_to_many_hint": "Multiple correct pairs allowed. Students can draw at most one line per source on matching questions.",
    "homework_temp_match_line_setup_title": "Matching question setup",
    "homework_temp_match_line_setup_desc": "Left and right can have different counts. Connect below by click or drag; each line uses a different color.",
    "homework_temp_match_line_interact_hint": "Click or drag from left, then click right to connect. Repeat to remove.",
    "homework_temp_drag_select_setup_title": "Drag & fill setup",
    "homework_temp_drag_select_setup_desc": "Left: answer pool. Right: each blank (sub-question + correct answer).",
    "homework_temp_drag_select_pool": "Answer pool",
    "homework_temp_drag_select_pool_hint": "Students drag from here",
    "homework_temp_drag_select_blanks": "Blanks",
    "homework_temp_drag_select_blanks_hint": "Sub-question text and correct answer per blank",
    "homework_temp_drag_select_pick_answer": "Correct answer",
    "homework_temp_question_drag_select_required": "Question {{index}} needs option pool, blanks, and correct answer per blank",
    "student_homework_drag_select_pool_hint": "Drag words into the blanks on the right",
    "student_homework_drag_select_drop_here": "Drop answer here",
    "student_homework_match_line_hint": "Click or drag from left to right. At most one line per left item.",
    "homework_temp_question_fill_blank_required": "Question {{index}} needs at least one blank item",
    "homework_temp_question_match_pair_required": "Question {{index}} needs match pairs and correct answers",
    "homework_temp_question_pointer_required": "Question {{index}} needs text, positions and correct answers",
    "homework_temp_essay_hint": "Essay requires teacher grading",
    "student_homework_fill_blank_placeholder": "Your answer",
    "student_homework_essay_placeholder": "Write your essay here",
    "student_homework_match_select_target": "Select match",
    "student_homework_pointer_hint": "Click the circles below the text to select positions (at least one)",
    "student_homework_pointer_label": "Multiple positions allowed",
    "homework_temp_question_mutil_select_hint": "Multiple choice, select at least 2 answers",
    "homework_temp_question_mutil_select_label": "Multiple",
    "homework_temp_question_mutil_select_answer_required": "Question {{index}} is multiple choice, at least 2 answers must be selected",
    "homework_temp_question_content": "Question Content",
    "homework_temp_question_desc": "Description",
    "homework_temp_question_options": "Options",
    "homework_temp_question_answer": "Answer",
    "homework_temp_question_index": "Question Number",
    "homework_temp_correct_answer": "Correct Answer",
    "homework_temp_need_teacher_read": "Requires Teacher Review",
    "homework_temp_question_score": "Question Score",
    "homework_temp_part_default_score": "Part Default Score",
    "homework_temp_manner_read": "Manual Grading",
    "homework_temp_exam_mode": "Exam Mode",
    "homework_temp_exam_duration": "Exam Duration (minutes)",
    "homework_temp_exam_duration_hint": "Minimum 5 minutes, default 90 minutes",
    "homework_temp_exam_tag": "Exam",
    "homework_assign_exam_alert": "This template is an exam. Please confirm the exam duration.",
    "homework_assign_exam_duration": "Exam Duration (minutes)",
    "homework_temp_simple_text_answer_placeholder": "Reference answer(s), optional, for teacher reference. Multiple lines = multiple acceptable answers.",
    "homework_temp_simple_text_answer_hint": "Short answers are graded by teachers; reference answers are not auto-scored.",
    "homework_temp_part_name": "Part Name",
    "homework_temp_part_desc": "Part Description",
    "homework_temp_upload_image": "Upload Image",
    "homework_temp_image_limit": "Image size cannot exceed 2M, maximum 30 images",
    "homework_temp_click_image_to_insert": "Click an image to insert it at the cursor position",
    "homework_temp_loading_detail": "Loading detail...",
    "homework_temp_cache_restored": "Data restored from cache",
    "homework_temp_cache_restore_failed": "Failed to restore cache",
    "homework_temp_name": "Template Name",
    "homework_temp_name_duplicate_hint": "A template with this name already exists in this bank",
    "homework_temp_name_duplicate_save": "Please change the template name before creating",
    "homework_temp_description": "Template Description",
    "homework_temp_name_required": "Please enter template name",
    "homework_temp_save_success": "Saved successfully",
    "homework_temp_save_failed": "Failed to save",
    "homework_temp_delete_confirm": "Are you sure you want to delete this template?",
    "homework_temp_delete_success": "Deleted successfully",
    "homework_temp_delete_failed": "Failed to delete",
    "homework_temp_migrate": "Migrate",
    "homework_temp_migrate_title": "Migrate Homework Template",
    "homework_temp_migrate_target_bank": "Target Homework Bank",
    "homework_temp_migrate_target_bank_placeholder": "Select target homework bank",
    "homework_temp_migrate_confirm": "Move \"{{name}}\" to the selected homework bank?",
    "homework_temp_migrate_success": "Migrated successfully",
    "homework_temp_migrate_failed": "Failed to migrate",
    "homework_temp_migrate_same_type_hint": "Templates can only be moved within the same bank type (e.g. public to public)",
    "homework_temp_migrate_no_target": "No other homework banks available for migration",
    "homework_temp_migrate_name_conflict": "A template with this name already exists in the target bank. Change the name first.",
    "homework_temp_upload_success": "File uploaded successfully",
    "homework_temp_upload_failed": "Failed to upload file",
    "homework_temp_question_click_load": "Click question to load detail",
    "homework_temp_image_count": "Image Count",
    "homework_temp_max_images": "Maximum 30 images",
    "homework_temp_image_too_large": "Image size cannot exceed 2M",
    "homework_temp_load_detail_failed_no_data": "Failed to load template detail: No data returned",
    "homework_temp_load_detail_failed": "Failed to load template detail",
    "homework_temp_parse_file_failed": "Failed to parse file: No valid data returned",
    "homework_temp_delete_part_confirm_title": "Confirm Delete",
    "homework_temp_delete_part_confirm_content": "Are you sure you want to delete this part? All questions in this part will also be deleted.",
    "homework_temp_question_content_empty": "Question {{index}} content cannot be empty",
    "homework_temp_question_select_answer_required": "Question {{index}} must have correct answer selected",
    "homework_temp_question_true_false_answer_required": "Question {{index}} must select correct answer (True/False)",
    "homework_temp_image_preview": "Image Preview",
    "homework_temp_validation_failed": "Validation failed",
    "homework_temp_confirm": "Confirm",
    "homework_temp_cancel_btn": "Cancel",
    "homework_temp_create": "Create",
    "homework_temp_add_part": "Add Part",
    "homework_temp_delete_part": "Delete Part",
    "homework_temp_insert_image": "Insert Image",
    "homework_temp_add_option": "Add Option",
    "homework_temp_preview": "Preview",
    "homework_temp_image": "Image",
    "homework_temp_option": "Option",
    "homework_temp_sort_order_setup_title": "Sort order setup",
    "homework_temp_sort_order_setup_desc": "Add items and drag to set the correct order. Full credit only when all positions are correct.",
    "homework_temp_sort_order_correct_order": "Correct order",
    "homework_temp_sort_order_drag_hint": "Drag to set top-to-bottom correct order",
    "homework_temp_sort_order_add_item": "Add item",
    "homework_temp_sort_order_item_placeholder": "Item text",
    "homework_temp_sort_order_incomplete": "Question configuration incomplete",
    "homework_temp_question_sort_order_required": "Question {{index}} needs at least 2 sort items and a correct order",
    "student_homework_sort_order_hint": "Drag to reorder (items are shuffled)",
    "homework_temp_question_audio": "Question audio",
    "homework_temp_audio_hint": "mp3, mp4 (audio), etc. Max 2MB. Crop and preview supported.",
    "homework_temp_audio_upload": "Upload audio",
    "homework_temp_audio_remove": "Remove audio",
    "homework_temp_audio_crop_title": "Crop audio",
    "homework_temp_audio_crop_desc": "Drag the slider to set start/end, or use the full clip",
    "homework_temp_audio_crop_range": "Crop range",
    "homework_temp_audio_use_full": "Use full audio",
    "homework_temp_audio_crop_confirm": "Apply crop",
    "homework_temp_audio_too_large": "Audio must be 2MB or less",
    "homework_temp_audio_format_invalid": "Only mp3, mp4 (audio), m4a, aac, webm, ogg, wav are supported",
    "homework_temp_audio_uploaded": "Audio saved",
    "homework_temp_audio_upload_failed": "Failed to upload audio",
    "homework_temp_audio_load_failed": "Failed to load audio",
    "homework_temp_audio_crop_failed": "Failed to crop audio",
    "homework_temp_audio_crop_too_short": "Crop range is too short",
    "homework_temp_audio_crop_preview_duration": "Cropped duration {{cropped}}s (original {{total}}s)",
    "homework_temp_question_audio_required": "Question {{index}} has audio enabled but no audio data",
    "homework_temp_question_type_writing_task": "Writing Task",
    "homework_temp_writing_task_hint": "Students may upload files or type text; teacher grading required",
    "writing_task_mode_file": "Upload file",
    "writing_task_mode_text": "Type text",
    "writing_task_switch_mode_title": "Switch submission mode",
    "writing_task_switch_mode_content": "Switching will clear current content. Continue?",
    "writing_task_upload_hint": "Drag or click to upload files",
    "writing_task_upload_count": "{{count}} / {{max}} files uploaded",
    "writing_task_selected_count": "{{count}} / {{max}} files selected",
    "writing_task_upload_on_submit_hint": "Files will upload when you save draft or submit",
    "writing_task_pending_tag": "Pending",
    "writing_task_uploaded_tag": "Uploaded",
    "writing_task_upload_progress": "Uploading attachments",
    "writing_task_upload_progress_hint": "Please wait and do not close this page until upload completes",
    "writing_task_no_files": "No files submitted",
    "writing_task_file_count": "{{count}} file(s)",
    "writing_task_view_file": "View",
    "writing_task_open_file_error": "Could not open file. Please try again later.",
    "writing_task_download_file": "Download",
    "writing_task_local_office_preview_hint": "Word documents can be previewed after you submit them.",
    "writing_task_preview": "Preview",
    "writing_task_text_placeholder": "Type your writing here",
    "writing_task_max_files": "Maximum {{max}} files allowed",
    "writing_task_upload_error": "Upload failed",
    "writing_task_upload_network_error": "Upload failed: connection closed. Check your network or ask admin to verify the server is updated.",
    "writing_task_delete_error": "Failed to delete file",
    "writing_task_student_files": "Student submission",
    "writing_task_feedback_files": "Feedback files",
    "writing_task_feedback_optional_hint": "Comments only is allowed; feedback files are optional",
    "writing_task_upload_feedback_hint": "Upload graded files (optional)",
    "writing_task_supplementary_files": "Supplementary materials",
    "writing_task_upload_supplementary_hint": "Upload supplementary files (optional)",
    "writing_task_revision_hint": "Edit below; revisions will be shown with track-changes style",
    "writing_task_original": "Original",
    "writing_task_revised": "Revised",
    "writing_task_teacher_revision": "Teacher revision",
    "writing_task_allowed_types": "JPG, PNG, PDF, Word, WPS text supported. Max 20MB per file.",
    "writing_task_file_type_invalid": "File type not allowed. Use JPG, PNG, PDF, Word, or WPS text.",
    "writing_task_file_too_large": "Each file must be {{maxMb}}MB or smaller.",

    "writing_rubric_content": "Content",
    "writing_rubric_organization": "Organization",
    "writing_rubric_language": "Language",
    "writing_rubric_grammar": "Grammar",
    "writing_task_grade_editor_hint": "Add paragraph notes without rewriting the whole essay; edit the revised draft to change wording.",
    "writing_task_grade_tab_edit": "Grade",
    "writing_task_grade_tab_preview": "Preview",
    "writing_task_paragraph_comments": "Paragraph notes",
    "writing_task_paragraph_label": "Paragraph {{index}}",
    "writing_task_paragraph_comment_label": "Teacher note",
    "writing_task_paragraph_comment_placeholder": "Suggestions for this paragraph…",
    "writing_task_paragraph_comments_preview": "Paragraph notes preview",
    "writing_task_rubric_title": "Rubric",
    "writing_task_rubric_max": "Max {{score}} pts",
    "writing_task_rubric_comment_placeholder": "Comment for this dimension (optional)",
    "writing_task_revision_preview": "Revision preview",
    "writing_task_no_revision_yet": "No text edits yet (paragraph notes only is fine)",
    "writing_task_live_preview": "Live preview",
    "writing_task_rubric_result_title": "Rubric scores",
    "writing_task_rubric_column_dimension": "Dimension",
    "writing_task_rubric_column_score": "Score",
    "writing_task_rubric_column_comment": "Comment",

    "create_homework_mode_bank": "From question bank",
    "create_homework_mode_quick_writing": "Quick writing",
    "quick_writing_hint": "Creates a template with an instruction block plus one writing task in your personal bank, then assigns it. Students may submit by file upload or typed text.",
    "quick_writing_homework_name": "Homework name",
    "quick_writing_homework_name_placeholder": "e.g. Week 3 Writing",
    "quick_writing_instruction": "Instruction block (optional)",
    "quick_writing_instruction_placeholder": "Requirements, word count, etc. Shown above the prompt",
    "quick_writing_prompt": "Writing prompt",
    "quick_writing_prompt_placeholder": "e.g. Write about your favorite pet.",
    "quick_writing_total_score": "Max score",
    "quick_writing_assign_btn": "Create & assign",
    "quick_writing_name_required": "Homework name is required",
    "quick_writing_prompt_required": "Writing prompt is required",
    "quick_writing_assign_error": "Quick writing assignment failed. Please try again.",

    "homework_bank_tab_temps": "Templates",
    "homework_bank_tab_grade_config": "Grade Settings",
    "homework_bank_tab_stats": "Score Statistics",
    "grade_band_description": "Grade description",
    "grade_band_description_placeholder": "Explain the grading bands for students and teachers",
    "grade_band_mode": "Band mode",
    "grade_band_mode_percentage": "Percentage bands",
    "grade_band_mode_absolute": "Absolute score bands",
    "grade_band_name": "Band name",
    "grade_band_name_required": "Band name is required",
    "grade_band_threshold_required": "Threshold is required",
    "grade_band_band_desc": "Band feedback (optional)",
    "grade_band_band_comment_placeholder": "Shown to students in this band; leave blank to hide",
    "grade_band_add_band": "Add band",
    "grade_band_preview": "Preview",
    "grade_band_save": "Save",
    "grade_band_reset_default": "Reset to default",
    "grade_band_save_success": "Grade settings saved",
    "grade_band_save_failed": "Failed to save",
    "grade_band_points": "pts",
    "grade_band_absolute_invalid": "Templates in this bank have different max scores; absolute bands are not allowed",
    "grade_band_max_score_hint": "This paper max score is {{score}} pts; the top band threshold should equal max score",
    "grade_band_temp_override_title": "Grade config (per template)",
    "grade_band_use_custom": "Use custom grade config",
    "grade_band_paper_max_score": "Max score",
    "grade_band_stats_empty": "No completion records yet",
    "grade_band_stats_total": "Completions",
    "grade_band_stats_distribution": "Grade distribution",
    "grade_band_stats_by_temp": "By template",
    "grade_band_stats_count": "Count",
    "grade_band_stats_avg_score": "Avg score",
    "grade_band_result_title": "Grade band",
};
